<template>
  <div class="pelak-box center-right">
    <div style="width: 20%" class="center">
      <div>
        <div class="center">
          <span class="iran-text">ایران</span>
        </div>
        <div class="center bold" style="font-size: 12px">{{ pelak[3] }}</div>
      </div>
    </div>

    <v-divider vertical></v-divider>

    <div
      style="width: 80%; position: relative; font-size: 14px"
      class="bold center pl-2 pt-1"
    >
      <img
        alt=""
        src="../assets/images/iran-flag.svg"
        width="18px"
        height="31px"
        style="position: absolute; top: -3px; left: -15px; border-radius: 3px"
      />
      {{ pelak[2] + pelak[1] + pelak[0] }}
    </div>
  </div>
</template>

<script>
export default {
  name: "NewPelak",
  props: {
    pelak: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.pelak-box {
  border-radius: 5px;
  background-color: #f2ab04;
  width: 100%;
  min-width: 100px !important;
  height: auto;
  border: 1px solid rgba(0, 0, 0, 0.5);
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.center-right {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.iran-text {
  font-size: 7px;
  color: rgba(0, 0, 0, 0.7);
}
</style>
